import React from 'react';
import { ExternalLink } from 'lucide-react';
import { openExternal } from '../../utils/openExternal';
import { Section } from '../settingsPrimitives';
import DeveloperSection from './DeveloperSection';

export const AboutTab = ({ t, appVersion, onReportIssue }) => (
  <>
    <div className="settings-about-app">
      <div className="settings-about-logo" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {/* The still brand mascot, not the animated auth Ghost — owner call
            (16.08.2026): About is a quiet page, and the login screen's bobbing
            ghost read as out of place under version-and-licences content. */}
        <img
          src="/apiboo-mascot-purple.png"
          alt="Apiboo"
          width={64}
          height={64}
          style={{ display: 'block' }}
        />
      </div>
      <div>
        <div className="settings-about-name">Apiboo</div>
        <div className="settings-about-tagline">{t('settings.aboutTagline')}</div>
        <div className="settings-about-badges">
          <span className="settings-badge">{appVersion || '…'}</span>
          <span className="settings-badge settings-badge--green">{t('settings.upToDateBadge')}</span>
        </div>
      </div>
    </div>

    <Section title={t('settings.resources')}>
      <div className="settings-resource-row">
        <div>
          <div className="settings-resource-label">{t('settings.documentation')}</div>
        </div>
        <button
          type="button"
          className="settings-resource-btn"
          onClick={() => openExternal('https://apiboo.com/docs')}
          aria-label={t('settings.documentation')}
        >
          {t('settings.open')} <ExternalLink size={12} />
        </button>
      </div>
      <div className="settings-resource-row">
        <div>
          <div className="settings-resource-label">{t('settings.changelog')}</div>
        </div>
        <button
          type="button"
          className="settings-resource-btn"
          onClick={() => openExternal('https://apiboo.com/changelog')}
          aria-label={t('settings.changelog')}
        >
          {t('settings.open')} <ExternalLink size={12} />
        </button>
      </div>
      <div className="settings-resource-row">
        <div>
          <div className="settings-resource-label">{t('settings.reportIssue')}</div>
        </div>
        <button
          type="button"
          className="settings-resource-btn"
          onClick={onReportIssue}
          aria-label={t('settings.reportIssue')}
        >
          {t('settings.open')} <ExternalLink size={12} />
        </button>
      </div>
      <div className="settings-resource-row">
        <div>
          <div className="settings-resource-label">Terms of Service</div>
        </div>
        <button
          type="button"
          className="settings-resource-btn"
          onClick={() => openExternal('https://apiboo.com/terms')}
          aria-label="Terms of Service"
        >
          {t('settings.open')} <ExternalLink size={12} />
        </button>
      </div>
      <div className="settings-resource-row">
        <div>
          <div className="settings-resource-label">Privacy Policy</div>
        </div>
        <button
          type="button"
          className="settings-resource-btn"
          onClick={() => openExternal('https://apiboo.com/privacy')}
          aria-label="Privacy Policy"
        >
          {t('settings.open')} <ExternalLink size={12} />
        </button>
      </div>
      {/* Stated, not linked. This row used to carry a "View" button opening
          https://apiboo.com/terms — the same destination as the Terms of
          Service row two above it, and a page that contains no licensing
          section at all. So the button both duplicated its neighbour and led
          somewhere that did not answer the question it posed. The licence IS
          the sentence below; the Terms row remains the single link to the legal
          document. If a dedicated licence page is written later, this row is
          where it goes. */}
      <div className="settings-resource-row">
        <div>
          <div className="settings-resource-label">{t('settings.license')}</div>
          <div className="settings-resource-desc">{t('settings.licenseDesc')}</div>
        </div>
      </div>
      <div className="settings-resource-row">
        <div>
          <div className="settings-resource-label">{t('settings.openSourceLibraries')}</div>
          <div className="settings-resource-desc">{t('settings.openSourceLibrariesDesc')}</div>
        </div>
        <button
          type="button"
          className="settings-resource-btn"
          onClick={() => openExternal('https://apiboo.com/libraries')}
          aria-label={t('settings.openSourceLibraries')}
        >
          {t('settings.view')} <ExternalLink size={12} />
        </button>
      </div>
    </Section>

    <DeveloperSection />
  </>
);
